import gql from 'graphql-tag'

export const SUBMIT_QUIZ = gql`
  mutation academySubmitQuiz($topicId: Int!, $content: QuizResponse!) {
    academySubmitQuiz(topicId: $topicId, content: $content) {
      userId
      contentResponse {
        questions {
          questionId
          title
          desc
          type
          media {
            id
            url
          }
          options {
            optionId
            title
            selected
            media {
              id
              url
            }
          }
        }
      }
    }
  }
`
